import { create } from 'zustand';
import { api } from '@/lib/api-client';

/**
 * Whose admin this is, before anyone has signed in (ADR-123).
 *
 * The sign-in page greets staff with the store's own name and logo, read from
 * the public settings — the same identity a shopper sees in the store's header,
 * so nothing private is asked for before a session exists. Once signed in, the
 * shell reads the workspace instead.
 */
interface IdentityState {
  name: string;
  logoUrl: string | null;
  loaded: boolean;
  load: () => Promise<void>;
}

export const useIdentityStore = create<IdentityState>((set, get) => ({
  name: '',
  logoUrl: null,
  loaded: false,

  async load() {
    if (get().loaded) return;

    try {
      const settings = await api.settings.public();
      set({
        name: settings['store.info']?.name ?? '',
        logoUrl: settings['branding.theme']?.logoUrl ?? null,
        loaded: true,
      });
    } catch {
      // The page still signs people in; it greets them as "Admin" instead.
      set({ loaded: true });
    }
  },
}));
